import FeedApp from '@alltrails/communityapp/feed';
import { contextPropTypes } from '../../../proptypes/shared';
// all third party styles
import 'react-image-lightbox/style.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'react-magic-slider-dots/dist/magic-dots.css';
import '@alltrails/communityapp/dist/feed.css';
import CustomProvider from 'components/CustomProvider';
import { handleLanguageChange } from '../../../utils/language_support_util';

const CommunityApp = ({ context, lists, facebookAppId, requestPath, featureFlags, usersAlgoliaIndexId }) => {
  const facebook = { appId: facebookAppId };

  const algoliaIndex = {
    usersAlgoliaIndexId: usersAlgoliaIndexId
  };

  return (
    <CustomProvider>
      <FeedApp
        context={context}
        lists={lists}
        facebook={facebook}
        requestPath={requestPath}
        featureFlags={featureFlags}
        algoliaIndex={algoliaIndex}
        handleLanguageChange={newLanguageRegionCode => handleLanguageChange(context.currentUser, newLanguageRegionCode)}
      />
    </CustomProvider>
  );
};

CommunityApp.propTypes = {
  context: contextPropTypes.isRequired
};

export default CommunityApp;
